import {
  FETCH_COURSE_BY_NAME,
  FETCH_COURSE_BY_ID,
  START_LOADING,
  END_LOADING,
  LIKE_COURSE,
  FETCH_MOST_LIKED_COURSES,
  ADD_COURSE,
  UPDATE_COURSE,
  UPDATED_COURSES,
  REMOVE_COURSE_UPDATE,
  FETCH_COURSES_NEARBY,
  RATE_COURSE,
} from "../constants/actionTypes";
import * as api from "../api";

export const getCourseByName = (name) => async (dispatch) => {
  try {
    dispatch({ type: START_LOADING });
    const { data } = await api.fetchCourseByName(name);
    dispatch({ type: FETCH_COURSE_BY_NAME, payload: data });
    dispatch({ type: END_LOADING });
  } catch (error) {
    console.log(error);
    dispatch({ type: END_LOADING });
  }
};

export const getCourseById = (id) => async (dispatch) => {
  try {
    dispatch({ type: START_LOADING });
    const { data } = await api.fetchCourseById(id);
    dispatch({ type: FETCH_COURSE_BY_ID, payload: data });
    dispatch({ type: END_LOADING });
  } catch (error) {
    console.log(error);
    dispatch({ type: END_LOADING });
  }
};

export const likeCourse = (id, anonymousId) => async (dispatch) => {
  try {
    const { data } = await api.likeCourse(id, anonymousId);
    dispatch({ type: LIKE_COURSE, payload: data });
  } catch (error) {
    console.log(error);
  }
};

export const getMostLikedCourses = () => async (dispatch) => {
  try {
    dispatch({ type: START_LOADING });
    const { data } = await api.fetchMostLikedCourses();
    dispatch({ type: FETCH_MOST_LIKED_COURSES, payload: data });
    dispatch({ type: END_LOADING });
  } catch (error) {
    console.log(error);
    dispatch({ type: END_LOADING });
  }
};

export const getCoursesNearby = (lat, lng) => async (dispatch) => {
  try {
    dispatch({ type: START_LOADING });
    const { data } = await api.fetchCoursesNearby(lat, lng);
    dispatch({ type: FETCH_COURSES_NEARBY, payload: data });
    dispatch({ type: END_LOADING });
  } catch (error) {
    console.log(error);
    dispatch({ type: END_LOADING });
  }
};

export const addCourse = (course, history) => async (dispatch) => {
  try {
    dispatch({ type: START_LOADING });
    const { data } = await api.addCourse(course);
    dispatch({ type: ADD_COURSE, payload: data });

    history.push(`/course/${data._id}`);

    dispatch({ type: END_LOADING });
  } catch (error) {
    console.log(error);
    dispatch({ type: END_LOADING });
  }
}

export const updateCourse = (course, history) => async (dispatch) => {
  try {
    dispatch({ type: START_LOADING });
    const { data } = await api.updateCourse(course);
    dispatch({ type: UPDATE_COURSE, payload: data });
    dispatch({ type: END_LOADING });
  } catch (error) {
    console.log(error);
    dispatch({ type: END_LOADING });
  }
}

export const getUpdatedCourses = () => async (dispatch) => {
  try {
    dispatch({ type: START_LOADING });
    const { data } = await api.fetchUpdatedCourses();
    dispatch({ type: UPDATED_COURSES, payload: data });
    dispatch({ type: END_LOADING });
  } catch (error) {
    console.log(error);
    dispatch({ type: END_LOADING });
  }
}

export const submitCourseUpdate = (course) => async (dispatch) => {
  try {
    await api.submitCourseUpdate(course);
    const { data: updatedCourses } = await api.fetchUpdatedCourses();
    dispatch({ type: UPDATED_COURSES, payload: updatedCourses });
  } catch (error) {
    console.log(error);
  }
}

export const rejectCourseUpdate = (id) => async (dispatch) => {
  try {
    await api.rejectCourseUpdate(id);
    dispatch({ type: REMOVE_COURSE_UPDATE, payload: id });
  } catch (error) {
    console.log(error);
  }
}

export const rateCourse = (id, value) => async (dispatch) => {
  try {
    const { data } = await api.rateCourse(id, value);
    dispatch({ type: RATE_COURSE, payload: data });
  } catch (error) {
    console.log(error);
  }
}

export const commentCourse = (id, comment) => async (dispatch) => {
  try {
    await api.commentCourse(id, comment);
  } catch (error) {
    console.log(error);
  }
}

export const getCourseComments = (id) => async (dispatch) => {
  try {
    const { data } = await api.getCourseComments(id);
    return data;
  } catch (error) {
    console.log(error);
  }
}

export const deleteCommentAction = (courseId, commentId) => async (dispatch) => {
  try {
    await api.deleteComment(courseId, commentId);
    const { data } = await api.getCourseComments(courseId);
    return data;
  } catch (error) {
    console.log(error);
  }
}